import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layouts/empty.vue").then(m => m.default || m))
}